import axios from "axios";

const API_URL =
  process.env.NODE_ENV === "production"
    ? `${window.location.origin}/api/emissions` // Automatically detects the production host
    : process.env.REACT_APP_API_URL || "http://localhost:5000/api/emissions";


export const fetchCalculationByEmissionId = async (emissionId) => {
  const response = await axios.get(`${API_URL}/calculate-emissions?emissionId=${emissionId}`);  
  return response.data;
};

export const calculateEmissions = async ({
  departure,
  arrival,
  passengers,
  cabinClass,
  tripType,
  operatingCarrierCode,
  flightNumber,
  departureDate,
  email,
  emissionId,
  isTermsAccepted,
}) => {
  try {
    const response = await axios.post(`${API_URL}/calculate-emissions`, {
      origin: departure,
      destination: arrival,
      passengers,
      cabinClass,
      tripType,
      operatingCarrierCode,
      flightNumber,
      departureDate, // Pass the new variables to the backend
      email,
      emissionId,
      isTermsAccepted,
    });
    return { success: true, data: response.data };
  } catch (error) {
    console.error("API Error:", error.response?.data?.error, error.response?.status);
    const status = error.response?.status;
    if (status === 400) {
      return { success: false, error: error.response?.data?.error };
    }
    return { success: false, error: "Failed to calculate emissions." };
  }
};
